import { gql } from "@apollo/client";

export const RESET_PASSWORD = gql`
  mutation ResetPassword(
    $password: String!
    $store: String
    $login: String!
    $eventId: String!
    $document: String!
  ) {
    ResetPassword(
      password: $password
      store: $store
      login: $login
      eventId: $eventId
      document: $document
    ) {
      status
      id
    }
  }
`;
